import { useEffect, useRef } from 'react'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import {
  readPendingGeneration,
  clearPendingGeneration,
  restoreGenerationSnapshot,
} from 'Pods/ThreeDStudio/Services/pendingGenerationStorage'
import { setPendingPostAuthGenerationTrigger } from 'Pods/ThreeDStudio/Store/actions/ui'

// Continues a generation a user asked for before leaving /ai (to create an account or to
// subscribe). GenerateButton stashes the form draft + pressed button in localStorage;
// leaving reloads /ai and wipes the store. Once the reloaded page reports the user as
// logged in, this restores the draft and arms pendingPostAuthGenerationTrigger so the
// matching button can replay its click.
//
// One-shot: the entry is read and erased on the first logged-in render. The draft is
// therefore restored once - if the user returned before the subscription webhook landed
// (still a non-generating tier), the button restores the form but does not auto-click, and
// a subsequent refresh finds nothing to restore, so the form comes up empty rather than
// re-filling from a stale draft.
function useResumePendingGeneration() {
  const pageConfig = usePageConfig()
  const isLoggedIn = pageConfig?.isCurrentUser ?? false
  const hasResumed = useRef(false)

  useEffect(() => {
    if (!isLoggedIn || hasResumed.current) {
      return
    }

    hasResumed.current = true

    const pending = readPendingGeneration()
    clearPendingGeneration()
    if (!pending) {
      return
    }

    restoreGenerationSnapshot(pending.snapshot)
    setPendingPostAuthGenerationTrigger(pending.triggerKey)
  }, [isLoggedIn])
}

export default useResumePendingGeneration
